// test1575
(1575 && 0);
